import React from 'react';
import { CardActions } from '../mol.card-actions';
import { ListCardBloco, ListCardInfo, ListCardStyled, ListCardSubtitle, ListCardTitle, ListCardTrailing, } from './list-card.component.style';
export var ListCard = function (_a) {
    var leading = _a.leading, title = _a.title, subtitle = _a.subtitle, trailing = _a.trailing, onClick = _a.onClick, actions = _a.actions, compacto = _a.compacto;
    var comAcoes = !!(actions === null || actions === void 0 ? void 0 : actions.length);
    var handleKeyDown = function (event) {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            onClick();
        }
    };
    return (React.createElement(ListCardBloco, { compacto: compacto },
        React.createElement(ListCardStyled, { clicavel: !!onClick, comAcoes: comAcoes, compacto: compacto, onClick: onClick, onKeyDown: handleKeyDown, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined },
            leading,
            React.createElement(ListCardInfo, null,
                React.createElement(ListCardTitle, null, title),
                subtitle && React.createElement(ListCardSubtitle, null, subtitle)),
            trailing && React.createElement(ListCardTrailing, null, trailing)),
        comAcoes && React.createElement(CardActions, { actions: actions, compacta: compacto })));
};
